import { Button } from '@mui/material'
import React from 'react'
import './pagenotfound.css'
import logo from "../assets/images/itwlogo.png";
import { NavLink } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import {Container, Grid } from '@mui/material';

const useStyles = makeStyles({
  header: {
    display: 'none'
  },
})

export default function PageNotFound () {
   const classes = useStyles()
  return (
    <div>
        <section class="page_404">
            <div class="container">
                <div class="row">   
                    <div class="col-sm-12 ">
                        <div class="col-sm-offset-1  text-center">
                            <div class="four_zero_four_bg">
                                {/* <NavLink to='/flight'><img src={logo} /></NavLink> */}
                                <h1 class="text-center ">404</h1>
                                <h4 class="text-center ">PAGE NOT FOUND</h4>
                            </div>
                            
                            <div class="contant_box_404">
                                <h3 class="h2">
                                    Look like you're lost
                                </h3>
                                
                                <p>The page you are looking for not available!</p>
                                
                                <NavLink to='/flight'><Button className='btn btn-secondary' href="" class="link_404">Go to Home</Button></NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
  )
}
